import React, { useState } from 'react';

import { Calendar } from 'primereact/calendar';
import { Button } from 'primereact/button';
import servicioObjetos from '../../../servicio/ServicioObjetos';
import { CALENDARIO_ES_MX } from '../../../servicio/ServicioConstantes';

export const Formulario = (props) => {

    const { onFormularioOk } = props;
    let { growl } = props;
    const [fecha, setFecha] = useState(null);
    const [render, setReder] = useState(true);

    const descargar = () => {
        if (servicioObjetos.esObjetoVacio(fecha)) {
            growl.current.clear();
            growl.current.show({ severity: 'error', summary: 'Error', detail: 'Debes de elegir un mes para descargar', life: 10000 });
            return;
        }
        onFormularioOk(fecha);
        setFecha(null);
        setReder(false);
        setTimeout(() => {
            setReder(true);
          }, 100);
    }

    return (
        <div>
            {render ? <div className="card-w-title">
                <h1>Seleccione Mes Año:</h1>
                <div className="p-grid">
                    <div className="p-col-12 p-md-3">
                        <Calendar locale={CALENDARIO_ES_MX} value={fecha} onChange={(e) => setFecha(e.value)} view="month" dateFormat="MM/yy" yearNavigator={true} yearRange="2022:2030" />
                    </div>
                    <div className="p-col-12 p-md-8">
                        <Button label="Solicitar" icon="pi-md-save" onClick={descargar} />
                    </div>
                </div>
            </div> : null}
        </div>
    );
}